import styled from 'styled-components'

export const SliderWrapper = styled.div`
  background-color: #010156;
  background-image: linear-gradient(90deg, #010156 63%, #404892 100%);
  color: white;
  text-align: center;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const SubTitle = styled.p`
  color: #ffffff;
  text-align: center;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 700;

  &::before,
  &::after {
    content: '-';
    margin: 0 1rem;
    color: #ffffff;
  }

  @media (max-width: 450px) {
    font-size: 14px !important;
  }
`

export const Title = styled.div`
  display: flex;
  gap: 0.6rem;
  font-size: 4rem;
  font-weight: 700;
  text-align: center;
  color: rgb(255, 255, 255);
  margin-bottom: 0;
  animation: fadeInUp;
  animation-duration: 15s;
  span {
    color: #f7931e;
  }
  @media screen and (max-width: 1050px) {
    font-size: 3rem;
  }
  @media (max-width: 840px) {
    font-size: 2rem;
  }
  @media (max-width: 520px) {
    font-size: 1.2rem;
  }
  @media (max-width: 420px) {
    font-size: 1.2rem;
    line-height: 1;
  }
`

export const Carousel = styled.div`
  padding-top: 20px;
  padding-bottom: 30px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
  margin: auto;
  flex-wrap: nowrap;
  position: relative;
  width: 100%;
  max-width: 1200px;
  perspective: 800px;
`

export const BrandCard = styled.div`
  background: #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.5s, scale 0.5s;
  position: relative;
  margin: 0 -20px;
  transition: all 0.3s ease;
  background: white;
  border-radius: 135px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  will-change: transform, opacity;

  &.active {
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    width: 120px;
    height: 80px;
    margin: 0 -15px;

    &.active {
      background: white;
      transform: scale(1.5);
    }
  }

  img {
    width: 80%;
  }

  @media (max-width: 1055px) {
    width: 200px;
    height: 170px;
    img {
      width: 60%;
    }
  }

  @media (max-width: 950px) {
    width: 180px;
    height: 120px;
  }

  @media (min-width: 768px) {
    width: 220px;
    height: 118px;
  }

  @media (max-width: 550px) {
    width: 150px;
    height: 100px;
  }
`

export const BrandLogo = styled.img`
  max-width: 100%;
  max-height: 80%;
  object-fit: contain;

  @media (min-width: 768px) {
    max-height: 60px;
  }
`
export const ControlButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 1rem;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  margin: auto 40px;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
  }
  &.hidden {
    display: none;
  }

  &.prev {
    left: 0;
  }

  &.next {
    right: 0;
  }
  @media (max-width: 800px) {
    width: 32px !important;
    height: 32px !important;
    svg {
      width: 20px;
      height: 20px;
    }
  }
`
export const MobileControlsWrapperLegacy = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 20px 0;
  position: absolute;
  bottom: 33%;
  button {
    position: static !important;
    transform: none !important;
  }

  @media (max-width: 550px) {
    bottom: 40%;
  }
`

export const MobileControlsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
`
